<!--
  Widerruf einer angeforderten Kontolöschung, über den Link aus der Mail.

  Wie Einladung.svelte: öffentlich und unauthentifiziert, weil der Zugang zu
  diesem Zeitpunkt gerade gesperrt ist — eine Anmeldung ist nicht möglich.
  Der Widerruf löst erst auf einen Klick aus, nicht schon beim Laden der
  Seite: Ein Mail-Scanner, der Links vorab abruft, soll keine Löschung
  widerrufen, die niemand angestoßen hat.
-->
<script lang="ts">
  import { api } from '../lib/api.ts';

  let { token }: { token: string } = $props();

  let fehler = $state<string | null>(null);
  let fertig = $state(false);
  let laeuft = $state(false);

  async function widerrufen(): Promise<void> {
    laeuft = true;
    fehler = null;
    try {
      await api.post('/api/portal/konto/loeschung-widerrufen', { token });
      fertig = true;
    } catch (f) {
      fehler = f instanceof Error ? f.message : 'Das hat nicht geklappt';
    } finally {
      laeuft = false;
    }
  }
</script>

<div class="anmeldeseite">
  <h1>Löschung widerrufen</h1>

  <div class="karte">
    {#if fertig}
      <p class="erfolg">Die Löschung Ihres Kontos ist widerrufen.</p>
      <p>Sie können sich jetzt wieder anmelden.</p>
      <div class="knopfreihe">
        <button type="button" onclick={() => (location.hash = '/')}>Zur Anmeldung</button>
      </div>
    {:else}
      <p>Möchten Sie die Löschung Ihres Kundenkontos rückgängig machen?</p>

      {#if fehler}<p class="fehler">{fehler}</p>{/if}

      <div class="knopfreihe">
        <button type="button" disabled={laeuft} onclick={widerrufen}>
          {laeuft ? 'Einen Moment …' : 'Ja, Löschung widerrufen'}
        </button>
      </div>
    {/if}
  </div>
</div>
